import { useQuery } from "@tanstack/react-query";

import API from "@/api";

function useNurseryStats(nurseryId: string) {
  const { isPending, error, data } = useQuery({
    queryKey: ["nursery-stats", nurseryId],
    queryFn: () => API.getNurseryStats(nurseryId)
  });

  return {
    isPending,
    error,
    data
  };
}

export default useNurseryStats;
